import React from "react";
import { Box, Spacer, Stack, Divider } from "digiwash-components";
import CustomIcon from "../CustomIcon";

function SkeletonUserAddressesList() {
  let loadingAddressesArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  return (
    <>
      {loadingAddressesArray.map(() => {
        return (
          <>
            <Box p="xl" bg="neutrals.250" br="l" style={{ width: "100%" }}>
              <Stack>
                <CustomIcon icon="subtract" width={26} height={32} />
                <Spacer size="l" />
                <Box
                  bg="common.white"
                  br="xs"
                  style={{ width: 127, height: 32 }}
                />
              </Stack>
              <Divider size="l" />
              <Box
                bg="common.white"
                br="xs"
                style={{ width: "100%", height: 24 }}
              />
            </Box>
            <Divider size="l" />
          </>
        );
      })}
    </>
  );
}

export default SkeletonUserAddressesList;
